import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "hamburger-wrapper",
    onClick: $setup.toggleMenu
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["hamburger-button", { active: $setup.active }])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass($setup.appStore.navigation.slideout.visible ? 'bg-gray-900' : 'bg-white')
      }, null, 2 /* CLASS */),
      _createElementVNode("span", {
        class: _normalizeClass($setup.appStore.navigation.slideout.visible ? 'bg-gray-900' : 'bg-white')
      }, null, 2 /* CLASS */),
      _createElementVNode("span", {
        class: _normalizeClass($setup.appStore.navigation.slideout.visible ? 'bg-gray-900' : 'bg-white')
      }, null, 2 /* CLASS */)
    ], 2 /* CLASS */)
  ]))
}